<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="tabsClick" v-model="tabVal">
      <el-tab-pane
        :name="item.key"
        :label="item.value"
        v-for="item in categoryNames"
        :key="item.key"
        v-loading="listLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#e6ebf54d"
      >
        <el-form
          :inline="true"
          ref="form"
          label-width="150px"
          style="width: 100%;min-height: 500px;"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="16" :xl="16">
              <!--              账户名称-->
              <el-form-item label="账户名称">
                <el-input
                  v-if="
                    isEdit &&
                      !['expend', 'raffle', 'exchange', 'deduction'].includes(accountObj.category)
                  "
                  v-model="accountObj.name"
                  placeholder="请输入"
                />
                <span v-else>{{ accountObj.name }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8" :xl="8" style="text-align: right">
              <el-button type="primary" v-show="!isEdit" @click="isEdit = true">编辑</el-button>
              <el-button type="success" v-show="isEdit" @click="saveOk" :loading="btnLoading"
                >保存</el-button
              >
            </el-col>
          </el-row>
          <div v-for="(cItem, index) in categoryList" :key="index">
            <el-card
              shadow="hover"
              :style="{
                'margin-bottom': '20px',
                border: cItem.type === 'current' ? '1px solid #fc6610' : '1px solid #3479b73d'
              }"
              v-if="(item.key !== 'raffle' && cItem.type !== 'quicken') || item.key === 'raffle'"
            >
              <!--              账户类型-->
              <div
                slot="header"
                class="clearfix"
                :style="{
                  'background-color': cItem.type === 'current' ? '#fc6610' : '#3479b73d'
                }"
              >
                <span>{{ getValue(ACCOUNT_TYPE, cItem.type) }}</span>
              </div>
              <el-row :gutter="10">
                <!--              状态-->
                <el-col :xs="24" :sm="24" :xl="24">
                  <el-form-item label="状态">
                    <el-switch
                      v-model="cItem.status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="!isEdit"
                      @change="event => statusChange(event, index)"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <!--              是否可用于支付-->
                <el-col
                  :xs="24"
                  :sm="24"
                  :xl="24"
                  v-if="
                    cItem.type === 'current' &&
                      cItem.status &&
                      ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                  "
                >
                  <el-form-item label="支付">
                    <el-switch
                      :disabled="!isEdit"
                      v-model="cItem.isPay"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <!--              是否可以充值-->
                <el-col
                  :xs="24"
                  :sm="24"
                  :xl="24"
                  v-if="
                    cItem.type === 'current' &&
                      cItem.status &&
                      ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                  "
                >
                  <el-form-item label="充值">
                    <el-switch
                      v-model="cItem.isRecharge"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="!isEdit"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <!--              是否可以抽奖-->
                <el-col :xs="24" :sm="24" :xl="24" v-if="cItem.status">
                  <el-form-item label="抽奖">
                    <el-switch
                      v-model="cItem.isRaffle"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="!isEdit"
                      @change="event => isRaffleChange(event, index)"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <!--              app显示顺序-->
                <!--              <el-col :xs="24" :sm="12" :xl="8">-->
                <!--                <el-form-item label="app显示顺序">-->
                <!--                  <el-input v-model="cItem.appSort" placeholder="请输入" />-->
                <!--                </el-form-item>-->
                <!--              </el-col>-->
              </el-row>
              <el-divider v-if="cItem.status"></el-divider>
              <!--              是否可以提现-->
              <el-form-item
                label="提现"
                v-if="
                  cItem.type === 'current' &&
                    cItem.status &&
                    ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                "
              >
                <el-switch
                  v-model="cItem.isWithdrawal"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                >
                </el-switch>
              </el-form-item>
              <el-row
                :gutter="10"
                v-if="
                  cItem.isWithdrawal &&
                    cItem.status &&
                    ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                "
              >
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="最少提现值">
                    <span v-if="!isEdit">{{ cItem.withdrawalRule.min }}</span>
                    <el-input
                      v-model="cItem.withdrawalRule.min"
                      placeholder="请输入"
                      size="small"
                      v-else
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="单日最大提现值">
                    <span v-if="!isEdit">{{ cItem.withdrawalRule.dayMax }}</span>
                    <el-input
                      v-model="cItem.withdrawalRule.dayMax"
                      placeholder="请输入"
                      size="small"
                      v-else
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="单日最大提现次数">
                    <span v-if="!isEdit">{{ cItem.withdrawalRule.dayTimes }}</span>
                    <el-input
                      v-model="cItem.withdrawalRule.dayTimes"
                      placeholder="请输入"
                      size="small"
                      v-else
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="提现手续费比例">
                    <span v-if="!isEdit">{{ cItem.withdrawalRule.rate }}%</span>
                    <el-input
                      v-model="cItem.withdrawalRule.rate"
                      placeholder="请输入"
                      size="small"
                      v-else
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider
                v-if="
                  cItem.type === 'current' &&
                    cItem.status &&
                    ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                "
              ></el-divider>
              <!--            购物赠送-->
              <el-form-item label="购物赠送" v-if="cItem.status">
                <el-switch
                  v-model="cItem.isGoodsGift"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                  @change="event => isGoodsGiftChange(event, index)"
                >
                </el-switch>
              </el-form-item>
              <el-row :gutter="10" v-if="cItem.isGoodsGift && cItem.status">
                <el-col :xs="24" :sm="6" :xl="6">
                  <el-form-item label="模式">
                    <span v-if="!isEdit">{{
                      getValue(GOODS_GIFT_RULE_MODEL, cItem.goodsGiftRule.model)
                    }}</span>
                    <el-select
                      v-model="cItem.goodsGiftRule.model"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-else
                    >
                      <el-option
                        v-for="item in GOODS_GIFT_RULE_MODEL"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :xl="6" v-if="[2, 3].includes(cItem.goodsGiftRule.model)">
                  <el-form-item label="固定值">
                    <span v-if="!isEdit">{{ cItem.goodsGiftRule.fixed }}</span>
                    <el-input
                      v-model="cItem.goodsGiftRule.fixed"
                      placeholder="请输入"
                      size="small"
                      v-else
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :xl="6" v-if="[2, 3].includes(cItem.goodsGiftRule.model)">
                  <el-form-item label="消费金额比例">
                    <span v-if="!isEdit">{{ cItem.goodsGiftRule.rate }}%</span>
                    <el-input
                      v-model="cItem.goodsGiftRule.rate"
                      placeholder="请输入"
                      size="small"
                      v-else
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :xl="6" v-if="[2, 3].includes(cItem.goodsGiftRule.model)">
                  <el-form-item label="面值">
                    <span v-if="!isEdit">{{ cItem.goodsGiftRule.parValue }}</span>
                    <el-input
                      v-model="cItem.goodsGiftRule.parValue"
                      placeholder="请输入"
                      size="small"
                      v-else
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider v-if="cItem.status"></el-divider>
              <!--            账户互转-->
              <el-form-item
                label="账户互转"
                v-if="
                  cItem.status &&
                    ['expend', 'raffle', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(
                      item.key
                    )
                "
              >
                <el-switch
                  v-model="cItem.isAcctTransfer"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                >
                </el-switch>
              </el-form-item>
              <el-row
                :gutter="10"
                v-if="
                  cItem.isAcctTransfer &&
                    cItem.status &&
                    ['expend', 'raffle', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(
                      item.key
                    )
                "
              >
                <template v-if="cItem.acctTransferRule.length !== 0">
                  <div v-for="(trItem, trIndex) in cItem.acctTransferRule" :key="trIndex">
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                      <el-form-item label="账户类别">
                        <span v-show="!isEdit">{{
                          getValue(cItem.categoryOption, trItem.category)
                        }}</span>
                        <el-select
                          v-model="trItem.category"
                          placeholder="请选择"
                          class="filter-item"
                          clearable
                          size="small"
                          v-show="isEdit"
                          v-el-select-loadmore="loadMore(rangeNumber)"
                        >
                          <el-option
                            v-for="o in cItem.categoryOption.slice(0, rangeNumber)"
                            :key="o.key"
                            :label="o.value"
                            :value="o.key"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                      <el-form-item label="账户类型">
                        <span v-show="!isEdit">{{ getValue(cItem.typesOption, trItem.type) }}</span>
                        <el-select
                          v-model="trItem.type"
                          placeholder="请选择"
                          class="filter-item"
                          clearable
                          size="small"
                          v-show="isEdit"
                          v-el-select-loadmore="loadMore(rangeNumber)"
                        >
                          <el-option
                            v-for="o in cItem.typesOption.slice(0, rangeNumber)"
                            :key="o.key"
                            :label="o.value"
                            :value="o.key"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                      <el-form-item label="互转模式">
                        <span v-if="!isEdit">{{
                          getValue(ACT_TRANSFER_RULE_MODEL, trItem.model)
                        }}</span>
                        <el-select
                          v-model="trItem.model"
                          placeholder="请选择"
                          class="filter-item"
                          clearable
                          size="small"
                          v-else
                          v-el-select-loadmore="loadMore(rangeNumber)"
                        >
                          <el-option
                            v-for="item in ACT_TRANSFER_RULE_MODEL.slice(0, rangeNumber)"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="['expend'].includes(item.key)">
                      <el-form-item label="互转方式">
                        <span v-if="!isEdit">{{
                          getValue(ACT_TRANSFER_RULE_METHOD, trItem.method)
                        }}</span>
                        <el-select
                          v-model="trItem.method"
                          placeholder="请选择"
                          class="filter-item"
                          clearable
                          size="small"
                          v-else
                          v-el-select-loadmore="loadMore(rangeNumber)"
                        >
                          <el-option
                            v-for="item in ACT_TRANSFER_RULE_METHOD.slice(0, rangeNumber)"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="trItem.model === 1">
                      <el-form-item label="金额计算方式">
                        <span v-if="!isEdit">{{
                          getValue(ACT_TRANSFER_RULE_AUTO_WAY, trItem.autoWay)
                        }}</span>
                        <el-select
                          v-model="trItem.autoWay"
                          placeholder="请选择"
                          class="filter-item"
                          clearable
                          size="small"
                          v-else
                          v-el-select-loadmore="loadMore(rangeNumber)"
                        >
                          <el-option
                            v-for="item in ACT_TRANSFER_RULE_AUTO_WAY.slice(0, rangeNumber)"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="trItem.model === 1">
                      <el-form-item label="自动互转时间点">
                        <span v-if="!isEdit">{{ trItem.timing }}点</span>
                        <el-select
                          v-model="trItem.timing"
                          placeholder="请选择"
                          class="filter-item"
                          clearable
                          size="small"
                          v-else
                        >
                          <el-option
                            v-for="(item, index) in 24"
                            :key="index"
                            :label="index"
                            :value="index"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="trItem.autoWay === 2">
                      <el-form-item label="自动互转比例">
                        <span v-show="!isEdit">{{ trItem.autoRate }}%</span>
                        <el-input
                          v-model="trItem.autoRate"
                          placeholder="请输入"
                          size="small"
                          v-show="isEdit"
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                      <el-form-item label="互转汇率">
                        <span v-if="!isEdit">{{ trItem.excRate }}</span>
                        <el-input
                          v-model="trItem.excRate"
                          placeholder="请输入"
                          size="small"
                          v-else
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="trItem.autoWay === 1">
                      <el-form-item label="自动互转固定值">
                        <span v-if="!isEdit">{{ trItem.autoFixed }}</span>
                        <el-input
                          v-model="trItem.autoFixed"
                          placeholder="请输入"
                          size="small"
                          v-else
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
                      <el-button
                        type="danger"
                        plain
                        size="medium"
                        @click="deleteHZ(index, trIndex)"
                        v-if="isEdit"
                        style="width: calc(100% - 150px)"
                        >删除</el-button
                      >
                    </el-col>
                    <el-col :xs="24" :sm="24" :xl="24">
                      <div class="fg_comm"></div>
                    </el-col>
                  </div>
                </template>
                <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
                  <el-button
                    type="success"
                    plain
                    style="width: calc(100% - 150px)"
                    size="medium"
                    @click="addTr(index)"
                    v-if="isEdit"
                    >添加</el-button
                  >
                </el-col>
              </el-row>
              <el-divider
                v-if="
                  cItem.status &&
                    cItem.status &&
                    ['expend', 'raffle', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(
                      item.key
                    )
                "
              ></el-divider>
              <!--            用户互转-->
              <el-row
                :gutter="10"
                v-if="
                  cItem.type !== 'lock' &&
                    cItem.status &&
                    ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                "
              >
                <el-col :xs="24" :sm="12" :xl="8">
                  <el-form-item label="用户互转">
                    <el-switch
                      v-model="cItem.isUserTransfer"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="!isEdit"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="16" v-if="cItem.isUserTransfer">
                  <el-form-item label="手续费比例">
                    <span v-if="!isEdit">{{ cItem.userTransferRule.rate }}%</span>
                    <el-input v-model="cItem.userTransferRule.rate" placeholder="请输入" v-else>
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider
                v-if="
                  cItem.type !== 'lock' &&
                    cItem.status &&
                    ['expend', 'vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
                "
              ></el-divider>
              <!--            是否开启系统赠送-->
              <el-form-item label="系统赠送" v-if="cItem.status">
                <el-switch
                  v-model="cItem.isSysGift"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                >
                </el-switch>
              </el-form-item>
              <el-row :gutter="10" v-if="cItem.isSysGift">
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="赠送基数">
                    <span v-if="!isEdit">{{ cItem.sysGiftRule.baseAmount }}</span>
                    <el-input
                      v-model="cItem.sysGiftRule.baseAmount"
                      placeholder="请输入"
                      size="small"
                      v-else
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="计算模式">
                    <span v-if="!isEdit">{{
                      getValue(SYS_GIFT_RULE_MODEL, cItem.sysGiftRule.model)
                    }}</span>
                    <el-select
                      v-model="cItem.sysGiftRule.model"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-else
                    >
                      <el-option
                        v-for="item in SYS_GIFT_RULE_MODEL"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="赠送周期">
                    <span v-if="!isEdit">{{
                      getValue(SYS_GIFT_RULE_CYCLE, cItem.sysGiftRule.cycle)
                    }}</span>
                    <el-select
                      v-model="cItem.sysGiftRule.cycle"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-else
                    >
                      <el-option
                        v-for="item in SYS_GIFT_RULE_CYCLE"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="cItem.sysGiftRule.cycle === 'w'">
                  <el-form-item label="每周具体日">
                    <span v-if="!isEdit">{{ getValue(WEEK_SEL, cItem.sysGiftRule.day) }}</span>
                    <el-select
                      v-else
                      v-model="cItem.sysGiftRule.day"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in WEEK_SEL"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="cItem.sysGiftRule.cycle === 'm'">
                  <el-form-item label="每月具体日">
                    <span v-if="!isEdit">{{ cItem.sysGiftRule.day }}日</span>
                    <el-select
                      v-else
                      v-model="cItem.sysGiftRule.day"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in 31"
                        :key="item"
                        :label="item + '日'"
                        :value="item"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="赠送时间点">
                    <span v-if="!isEdit">{{ cItem.sysGiftRule.hour }} 点</span>
                    <el-select
                      v-model="cItem.sysGiftRule.hour"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-else
                    >
                      <el-option
                        v-for="(item, index) in 24"
                        :key="index"
                        :label="index + '点'"
                        :value="index"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider v-if="cItem.status"></el-divider>
              <!--              会否开启清零-->
              <el-form-item
                label="开启清零"
                v-if="cItem.status && item.key == 'raffle' && cItem.type === 'quicken'"
              >
                <el-switch
                  v-model="cItem.isClear"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                >
                </el-switch>
              </el-form-item>
              <el-row
                :gutter="10"
                v-if="cItem.isClear && item.key === 'raffle' && cItem.type === 'quicken'"
              >
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="清零周期">
                    <span v-if="!isEdit">{{
                      getValue(SYS_GIFT_RULE_CYCLE, cItem.clearRule.cycle)
                    }}</span>
                    <el-select
                      v-model="cItem.clearRule.cycle"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-else
                    >
                      <el-option
                        v-for="item in SYS_GIFT_RULE_CYCLE"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="cItem.clearRule.cycle === 'w'">
                  <el-form-item label="每周具体日">
                    <span v-if="!isEdit">{{ getValue(WEEK_SEL, cItem.clearRule.day) }}</span>
                    <el-select
                      v-else
                      v-model="cItem.clearRule.day"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in WEEK_SEL"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl" v-if="cItem.clearRule.cycle === 'm'">
                  <el-form-item label="每月具体日">
                    <span v-if="!isEdit">{{ cItem.clearRule.day }}日</span>
                    <el-select
                      v-else
                      v-model="cItem.clearRule.day"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in 31"
                        :key="item"
                        :label="item + '日'"
                        :value="item"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="清零时间点">
                    <span v-if="!isEdit">{{ cItem.clearRule.hour }} 点</span>
                    <el-select
                      v-model="cItem.clearRule.hour"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-else
                    >
                      <el-option
                        v-for="(item, index) in 24"
                        :key="index"
                        :label="index + '点'"
                        :value="index"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getCategoryNames,
  getCategoryConfig,
  editCategoryConfig,
  getAcctTransferCategory
} from "@/api/system.js";
import {
  getValue,
  ACCOUNT_TYPE,
  GOODS_GIFT_RULE_MODEL,
  ACT_TRANSFER_RULE_MODEL,
  ACT_TRANSFER_RULE_AUTO_WAY,
  SYS_GIFT_RULE_MODEL,
  SYS_GIFT_RULE_CYCLE,
  WEEK_SEL,
  ACT_TRANSFER_RULE_METHOD
} from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import { toFixedNumFun } from "@/utils";

export default {
  computed: {
    GOODS_GIFT_RULE_MODEL() {
      return GOODS_GIFT_RULE_MODEL;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    ACT_TRANSFER_RULE_MODEL() {
      return ACT_TRANSFER_RULE_MODEL;
    },
    ACT_TRANSFER_RULE_AUTO_WAY() {
      return ACT_TRANSFER_RULE_AUTO_WAY;
    },
    SYS_GIFT_RULE_MODEL() {
      return SYS_GIFT_RULE_MODEL;
    },
    SYS_GIFT_RULE_CYCLE() {
      return SYS_GIFT_RULE_CYCLE;
    },
    WEEK_SEL() {
      return WEEK_SEL;
    },
    ACT_TRANSFER_RULE_METHOD() {
      return ACT_TRANSFER_RULE_METHOD;
    },
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      tabVal: null,
      categoryNames: [],
      listLoading: true,
      categoryList: [], // 当前对象
      accountObj: {}, // 账户名称
      itemSm: 12,
      itemXl: 8,
      isEdit: false,
      btnLoading: false,
      rangeNumber: 10
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    loadMore(n) {
      // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数  可自定义
    },
    /**
     * 查询用户列表
     */
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      getCategoryNames()
        .then(response => {
          let data = [];
          if (response && response.bizcode === 100) {
            data = response.data;
          }
          if (data && data.length !== 0) {
            const name = data[0].key;
            this.tabVal = name;

            this.tabsClick({ name });
          }
          this.categoryNames = data;
        })
        .finally(() => {
          loading.close();
        });
    },
    /**
     * tab 切换
     * @param e
     */
    async tabsClick(e) {
      this.tabVal = e.name;
      this.listLoading = true;
      this.categoryList = [];
      this.isEdit = false;
      const params = {
        category: e.name
      };
      const resp = await getCategoryConfig(params);
      let data = [];
      if (resp && resp.bizcode === 100) {
        const currentData = resp.data || [];
        data = currentData;
        this.accountObj = currentData[0];
      }
      if (data && data.length !== 0) {
        // 移动的对象
        let itemToMove = {};
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          // 查询账户互转类别
          const optionResp = await this.getAcctTransferCategory(e.name, item.type);
          item.categoryOption = optionResp.categorys; // 编辑删除了
          item.typesOption = optionResp.types; // 编辑删除了
          if (item.type === "current") {
            itemToMove = item;
          }
          item.status = item.status === 1; // 状态
          // 提现规则
          if (!item.withdrawalRule) {
            item.withdrawalRule = {};
          } else {
            // item.withdrawalRule.rate = item.withdrawalRule.rate? item.withdrawalRule.rate * 100 : null;
            item.withdrawalRule = JSON.parse(item.withdrawalRule);
            item.withdrawalRule.rate = item.withdrawalRule.rate
              ? item.withdrawalRule.rate * 100
              : null;
          }
          // 购物赠送规则
          if (!item.goodsGiftRule) {
            item.goodsGiftRule = {};
          } else {
            item.goodsGiftRule = JSON.parse(item.goodsGiftRule);
            item.goodsGiftRule.rate = item.goodsGiftRule.rate
              ? item.goodsGiftRule.rate * 100
              : null;
          }
          // 账户互转规则
          if (!item.acctTransferRule) {
            item.acctTransferRule = [];
          } else {
            const acctTransferRuleData = JSON.parse(item.acctTransferRule);
            acctTransferRuleData.map(item => {
              item.autoRate = item.autoRate ? item.autoRate * 100 : null;
            });
            item.acctTransferRule = acctTransferRuleData;
            // item.acctTransferRule.autoRate = item.acctTransferRule.autoRate
            //   ? item.acctTransferRule.autoRate * 100
            //   : null;
          }
          // 用户互转规则
          if (!item.userTransferRule) {
            item.userTransferRule = {};
          } else {
            item.userTransferRule = JSON.parse(item.userTransferRule);
            item.userTransferRule.rate = item.userTransferRule.rate
              ? item.userTransferRule.rate * 100
              : null;
          }
          // 系统赠送配置
          if (!item.sysGiftRule) {
            item.sysGiftRule = {};
          } else {
            item.sysGiftRule = JSON.parse(item.sysGiftRule);
          }
          // 清零配置
          if (!item.clearRule) {
            item.clearRule = {};
          } else {
            item.clearRule = JSON.parse(item.clearRule);
          }
        }
        // 调整顺序
        let index = data.findIndex(item => item.type === itemToMove.type); // 使用findIndex找到索引
        if (index > -1) {
          data.splice(index, 1); // 从原位置移除
          data.unshift(itemToMove); // 添加到数组第一位
        }
      }
      this.categoryList = data;
      this.listLoading = false;
    },

    /**
     * 查询账户互转类别
     */
    async getAcctTransferCategory(category, type) {
      const params = {
        category,
        type
      };
      const resp = await getAcctTransferCategory(params);
      if (resp && resp.bizcode === 100) {
        return resp.data;
      } else {
        return [];
      }
    },
    /**
     * 添加账户相互转换的item
     * @param index
     */
    addTr(index) {
      const data = this.categoryList[index].acctTransferRule;
      data.push({
        category: null,
        type: null,
        model: null,
        timing: null,
        autoWay: null,
        autoFixed: null,
        autoRate: null,
        excRate: null
      });
      this.categoryList[index].acctTransferRule = data;
    },
    // 删除账户互转
    deleteHZ(index, trIndex) {
      this.categoryList[index].acctTransferRule.splice(trIndex, 1);
    },

    /**
     * 处理参数
     * @param paramList
     */
    processingParameter(paramList) {
      if (!paramList || paramList.lemgth === 0) {
        return [];
      }
      const newParamList = paramList;
      for (let i = 0; i < newParamList.length; i++) {
        const item = newParamList[i];
        // 提现手续比例
        const withdrawalRuleRate = item.withdrawalRule.rate;
        if (withdrawalRuleRate) {
          item.withdrawalRule.rate = toFixedNumFun(withdrawalRuleRate, "save");
        }
        // 消费金额比例
        const goodsGiftRuleRate = item.goodsGiftRule.rate;
        if (goodsGiftRuleRate) {
          item.goodsGiftRule.rate = toFixedNumFun(goodsGiftRuleRate, "save");
        }
        // 手续费比例
        const userTransferRuleRate = item.userTransferRule.rate;
        if (userTransferRuleRate) {
          item.userTransferRule.rate = toFixedNumFun(userTransferRuleRate, "save");
        }
        // 账户互转规则
        const acctTransferRule = item.acctTransferRule;
        if (acctTransferRule && acctTransferRule.length !== 0) {
          for (let j = 0; j < acctTransferRule.length; j++) {
            const cItem = acctTransferRule[j];
            if (cItem.autoRate) {
              cItem.autoRate = toFixedNumFun(cItem.autoRate, "save");
            }
            acctTransferRule[j] = cItem;
          }
          item.acctTransferRule = acctTransferRule;
        }
        item.acctTransferRule = JSON.stringify(item.acctTransferRule);
        item.withdrawalRule = JSON.stringify(item.withdrawalRule);
        item.userTransferRule = JSON.stringify(item.userTransferRule);
        item.goodsGiftRule = JSON.stringify(item.goodsGiftRule);
        item.sysGiftRule = JSON.stringify(item.sysGiftRule);
        item.clearRule = JSON.stringify(item.clearRule);
        item.status = item.status ? 1 : 0;

        delete item.categoryOption;
        delete item.typesOption;

        newParamList[i] = item;
      }
      return newParamList;
    },

    /**
     * 确认添加还是编辑
     */
    async saveOk() {
      const loading = this.$loading({
        lock: true,
        text: "保存中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const accountName = this.accountObj.name;
      const categoryList = this.categoryList;
      // 分发name
      if (accountName) {
        categoryList.map(item => {
          item.name = accountName;
        });
      }
      const dataParams = this.processingParameter(categoryList);
      const res = await editCategoryConfig(dataParams);
      loading.close();
      this.tabsClick({ name: this.tabVal });
      if (res && res.bizcode === 100) {
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 2000
        });
      }
    },
    /**
     * 检查是否存在其他项
     * @param name
     * @param index
     */
    checkIsExit(name, index) {
      const data = this.categoryList;
      let flot = false;
      if (data && data.length !== 0) {
        data.map((item, k) => {
          if (item[name] && k !== index) {
            flot = true;
          }
        });
      }
      return flot;
    },
    setIsExit(name, index) {
      const data = this.categoryList;
      if (data && data.length !== 0) {
        data.map((item, k) => {
          if (item[name] && k !== index) {
            item[name] = false;
          }
        });
      }
      this.categoryList = data;
    },
    /**
     * 是否抽奖的切换
     * @param val
     */
    isRaffleChange(val, index) {
      // 打开时，需要问下
      if (val && this.checkIsExit("isRaffle", index)) {
        this.$confirm("其他账户已开启抽奖，是否把其他账户的关掉，开启此账户的抽奖？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.setIsExit("isRaffle", index);
          })
          .catch(() => {
            this.categoryList[index].isRaffle = false;
          });
      }
    },
    /**
     * 购物赠送的切换
     * @param val
     */
    isGoodsGiftChange(val, index) {
      // 打开时，需要问下
      if (val && this.checkIsExit("isGoodsGift", index)) {
        this.$confirm(
          "其他账户已开启购物赠送，是否把其他账户的关掉，开启此账户购物赠送？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.setIsExit("isGoodsGift", index);
          })
          .catch(() => {
            this.categoryList[index].isGoodsGift = false;
          });
      }
    },
    /**
     * 状态切换
     */
    statusChange(event, index) {
      const categoryList = this.categoryList;
      const currentData = this.categoryList[index];
      const lockAmount = categoryList.find(item => item.type === "lock");
      if (event && currentData.type === "quicken" && !lockAmount.status) {
        this.$confirm("锁定账户状态未启用，加速释放状态用户不能使用～", "标题", {
          confirmButtonText: "确定",
          showCancelButton: false, // 隐藏取消按钮
          type: "warning"
        }).then(() => {
          this.categoryList[index].status = false;
        });
      }
      // 释放掉加速释放账户的状态
      if (!event && currentData.type === "lock") {
        const quIndex = categoryList.findIndex(item => item.type === "quicken");
        this.categoryList[quIndex].status = false;
      }
    }
  },
  directives: {
    "el-select-loadmore": (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fg_comm {
  width: 100%;
  margin: 10px 0 20px;
  border: 1px dashed #eeeeee;
}
::v-deep .el-card__header {
  padding: 0px;
}
.clearfix {
  padding: 14px 20px;
}
</style>
